import './index.scss';

import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { showToast } from '@/src/globalFunction';
import { RootState } from '@/src/reducers/types';

import { useCreateFolder } from '../../../api/createFolder';

const CreateFolder = ({ projectId, onClose }) => {
  const files = useSelector((state: RootState) => state.files);
  const createFolderMutation = useCreateFolder();
  const [updatedName, setUpdatedName] = useState('');

  const handleCancel = () => {
    setUpdatedName('');

    onClose();
  };

  const handleInputChange = (e) => {
    setUpdatedName(e.target.value);
  };

  const handleSaveAndClose = async () => {
    const response = await handleSave();

    if (response.status === false && response?.reason === 'duplicate') {
      showToast(
        'error',
        'Please rename the folder because a folder with the same name already exists'
      );
      return;
    }

    handleCancel();
    showToast('success', `${updatedName} has been created`);
  };

  const handleSave = async () => {
    const response = await createFolderMutation.mutateAsync({
      projectId,
      parentId: files.activeFolder !== 'null' ? files.activeFolder.id : null,
      name: updatedName,
    });

    return response;
  };

  return (
    <React.Fragment>
      <div
        className="modal fade show in create-folder-modal bg-overlay"
        data-backdrop="static"
        data-keyboard="false"
        id="createFolder"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bb pd20 pdl40 pdr40">
              <div className="row">
                <div className="col-lg-10 col-md-10 col-sm-10">
                  <p className="text-size18 brndnTxt-m m0">Create a Folder</p>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                  <a onClick={handleCancel}>
                    <i className="material-icons text-size22">close</i>
                  </a>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <input
                type="text"
                placeholder="Untitled Folder"
                value={updatedName}
                onChange={handleInputChange}
              />
            </div>
            <div className="modal-footer bt">
              <div className="footerActions">
                <div className="actionButton">
                  <button type="button" className="btn btnCancel" onClick={handleCancel}>
                    Cancel
                  </button>
                </div>
                <div className="actionButton others">
                  <button
                    type="button"
                    className={`btnDone ${updatedName ? 'active' : ''}`}
                    onClick={handleSaveAndClose}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateFolder;
